import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CrowdfundingPage = lazy(() => import('../pages/crowdfunding/page'));
const FCCTechnologyPage = lazy(() => import('../pages/fcc-technology/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/crowdfunding',
    element: <CrowdfundingPage />,
  },
  {
    path: '/fcc-technology',
    element: <FCCTechnologyPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
